var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6738 10.8944L11.6739 10.8944C11.7754 10.9282 11.7754 11.0718 11.6739 11.1056L11.6738 11.1056L9.73744 11.7511C9.73744 11.7511 9.73743 11.7511 9.73743 11.7511C8.79961 12.0637 8.0637 12.7996 7.75111 13.7374C7.75111 13.7374 7.75111 13.7374 7.75111 13.7374L7.10564 15.6738C7.07181 15.7753 6.92823 15.7753 6.8944 15.6738L6.2489 13.7374C5.9363 12.7996 5.2004 12.0637 4.26258 11.7511L2.32613 11.1056L2.32612 11.1056C2.22462 11.0718 2.22462 10.9282 2.32612 10.8944L2.32613 10.8944L4.26258 10.2489C5.2004 9.93628 5.9363 9.20038 6.2489 8.26258L6.8944 6.32613C6.92823 6.22463 7.0718 6.22462 7.10564 6.32613L7.75111 8.26256L7.98828 8.1835L7.75111 8.26256C8.06371 9.20036 8.79961 9.93627 9.73742 10.2489C9.73742 10.2489 9.73742 10.2489 9.73743 10.2489L11.6738 10.8944Z",
    fill: "#FCD34D",
    fillOpacity: 0.8,
    stroke: "#FCD34D",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96852 6.7727L3.00001 6.7832L2.96852 6.77271C2.96852 6.7727 2.96853 6.77268 2.96853 6.77267L2.96852 6.7727ZM2.64421 2.38917L3.00001 1.32178L3.3558 2.38916C3.55331 2.98171 4.01829 3.44669 4.61084 3.6442L5.67823 4L4.61084 4.35579C4.01829 4.5533 3.55331 5.01828 3.3558 5.61083L3.00001 6.67822L2.64421 5.61082C2.4467 5.01827 1.98172 4.5533 1.38918 4.35579L0.321786 4L1.38918 3.6442C1.98173 3.44669 2.4467 2.98172 2.64421 2.38917C2.64421 2.38917 2.64421 2.38917 2.64421 2.38917Z",
    fill: "#FCD34D",
    fillOpacity: 0.8,
    stroke: "#FCD34D",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1581 0.95246L10.1581 0.952464C10.2981 1.37237 10.6276 1.70189 11.0475 1.84186C11.0475 1.84186 11.0475 1.84186 11.0475 1.84186L11.522 2L11.0476 2.15813C11.0476 2.15814 11.0475 2.15814 11.0475 2.15814C10.6276 2.29811 10.2981 2.62764 10.1581 3.04752L10.1581 3.04753L10 3.52191L9.84187 3.04753C9.7019 2.62761 9.37239 2.29811 8.95248 2.15814L8.47806 2L8.95248 1.84186L8.95248 1.84186C9.37239 1.70189 9.7019 1.37238 9.84187 0.952467L10 0.478087L10.1581 0.95246ZM8.17788 2.10005L8.17789 2.10005L8.17788 2.10005Z",
    fill: "#FCD34D",
    fillOpacity: 0.8,
    stroke: "#FCD34D",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.eab20ee4.svg";
export { ForwardRef as ReactComponent };